module.exports = __webpack_public_path__ + "img/Willem.7a58f4c4.jpg";